import script from "./DiagnosticsRun_bak_20260408.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsRun_bak_20260408.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__